<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div style="margin-bottom: 8px">
        <DxToolbar>
          <DxItem
            #default
            location="before"
            locate-in-menu="never"
          >
            <div class="toolbar-label"><b>조업일수 : {{operatingDay}}</b></div>
          </DxItem>
          <DxItem
            #default
            location="after"
            locate-in-menu="never"
          >
            <DxButton
              text='초기화'
              type='danger'
              width='70'
              @click="resetWeek($event)"
            />
          </DxItem>
        </DxToolbar>
      </div>
      <DxScheduler
        :data-source="dataSource"
        :current-date="currentDate"
        :views="['month']"
        :height="730"
        :start-day-hour="0"
        current-view="month"
        :on-appointment-added="onAppointmentAdded"
        :on-appointment-updated="onAppointmentUpdated"
        :on-appointment-deleted="onAppointmentDeleted"
        @option-changed="handlePropertyChange"
        :show-all-day-panel="false"
        all-day-expr="allDay"
      >
        <DxResource
          :data-source="resourcesData"
          field-expr="text"
          label="종류"
        />
        <DxEditing
          :allow-dragging="false"
        />
      </DxScheduler>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import DxTabPanel from 'devextreme-vue/tab-panel'
import { DxScheduler, DxEditing, DxResource } from 'devextreme-vue/scheduler'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import { DxButton } from 'devextreme-vue'
import AppLib from '../../share/AppLib'
import HttpService from '../../share/service/HttpService'
import ConstDef from '../../share/ConstDef'
// import HttpService from '../../share/service/HttpService'
export default {
  name: 'operatingDays',
  data: function () {
    return {
      tabs: [
        {
          title: '조업일관리'
        }
      ],
      selectedIndex: 0,
      dataSource: [],
      operatingDay: 0,
      currentDate: AppLib.getToday(),
      selectedDate: AppLib.getToday().substring(0, 7),
      resourcesData: [
        {
          text: '토요일',
          id: '토요일',
          color: 'cornflowerblue'
        }, {
          text: '일요일',
          id: '일요일',
          color: 'lightcoral'
        }, {
          text: '휴일',
          id: '휴일'
        }
      ]
    }
  },
  components: {
    DxTabPanel,
    DxScheduler,
    DxEditing,
    DxResource,
    DxToolbar,
    DxItem,
    DxButton
  },
  watch: {
    dataSource (newData) {
      console.log(newData)
    },
    currentDate (newData) {
      console.log(newData)
    }
  },
  created () {

  },
  mounted () {
    console.log(this.dataSource)
    this.refreshOperatingDays()
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    refreshOperatingDays () {
      this.$_sp.runNoEncodeFindSqlProc('조업정보', { 계획연월: this.selectedDate })
        .then((data) => {
          this.dataSource = this.$_sp.MakeModel(data)
          const gByDate = this.$_.groupBy(this.dataSource, function (list) { return list.startDate })
          const count = (Object.keys(gByDate)).length
          const splitDate = this.selectedDate.split('-')
          const days = AppLib.getMonthLastDay(splitDate[0], splitDate[1])
          this.operatingDay = days - count
          // console.log(this.divisionList)
        })
    },
    resetWeek () {
      const splitDate = this.selectedDate.split('-')
      HttpService.reqPost({ }, `/resetRestWeek?year=${splitDate[0]}&month=${splitDate[1]}`)
        .then((data) => {
          this.isLoading = false
          this.$snotify.info(data.result)
          this.refreshOperatingDays()
        })
    },
    onAppointmentAdd (e) {
      console.log(e)
      // const index = tasks.value.indexOf(e.fromData);

      // if (index >= 0) {
      //   tasks.value = [...tasks.value];
      //   tasks.value.splice(index, 1);
      //   appointments.value = [...appointments.value, e.itemData];
      // }
    },
    handlePropertyChange (e) {
      if (e.name === 'currentDate') {
        console.log(e.value)
        const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(e.value)
        const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(e.value)
        this.selectedDate = `${year}-${month}`
        this.refreshOperatingDays()
      }
    },
    onAppointmentAdded (e) {
      console.log(e.appointmentData)
      const param = {
        계획연월: this.selectedDate,
        startDate: e.appointmentData.startDate,
        endDate: e.appointmentData.startDate,
        text: e.appointmentData.text,
        allDay: true,
        휴무여부: true

      }
      this.$_sp.runInsertSqlProc('조업정보', null, [param])
        .then((data) => {
          this.$snotify.info('저장되었습니다.')
          this.refreshOperatingDays()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onAppointmentDeleted (e) {
      console.log(e.appointmentData.id)
      this.$_sp.runDeleteSqlProc('조업정보', [{ id: e.appointmentData.id }])
        .then((data) => {
          this.$snotify.info('삭제 되었습니다.')
          this.refreshOperatingDays()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onAppointmentUpdated (row) {
      this.$_sp.runUpdateSqlProc('조업정보', ['id'], null, [row.appointmentData])
        .then((data) => {
          this.$snotify.info('수정 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.test {
  color: lightcoral;
  color: cornflowerblue
}
</style>
